<template>
    <div class="header-outer">
        <h3>FutureNet Products Packs</h3>
        <h3>Total amount to FutureNet: {{ amount }}</h3>
    </div>
</template>

<script>
    export default {
        dependencies: ['money'],
        computed: {
            amount () {
                return 'FND ' + this.money.format(this.$store.getters.user.future_net_upgrade_account_balance, 'fnd');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .header-outer{
        display: flex;
        justify-content: space-between;
        align-items: center;

        h3{
            margin-bottom: 35px;
        }

        @media(max-width: 991px){
            display: block;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/fnproductpacks/Header.vue